import { gql } from '@apollo/client';

const LOCALIZED_TEXT_FRAGMENT = gql`
  fragment LocalizedTextFields on LocalizedText {
    es
    en
  }
`;

export default LOCALIZED_TEXT_FRAGMENT;
